import { extends as _extends, toArray as _toArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import TextField from './TextField.js';
import useConfigWithExtraValidation from '../../utils/form/useExtraFieldValidation.js';

function getInvalidNameError(value) {
  if (value) {
    var _value$split = value.split(' '),
      _value$split2 = _toArray(_value$split),
      lastNameParts = _value$split2.slice(1);
    var lastName = lastNameParts.join(' ');
    if (!lastName) {
      return 'Last name required';
    }
  }

  // else its blank validate, I don't enforce "required" in this rule. No errors.
  return null;
}
function NameField(textFieldProps) {
  return /*#__PURE__*/React.createElement(TextField, _extends({}, textFieldProps, {
    autoComplete: "name",
    config: useConfigWithExtraValidation(textFieldProps.config, getInvalidNameError)
  }));
}
NameField.propTypes = process.env.NODE_ENV !== "production" ? TextField.propTypes : {};
NameField.defaultProps = TextField.defaultProps;

export { NameField as default };
